import { render } from "./ConnectionMonitor.vue?vue&type=template&id=58d8e87d"
import script from "./ConnectionMonitor.vue?vue&type=script&lang=js"
export * from "./ConnectionMonitor.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__